import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AdditionalDeputateModal } from '../../../../components/AdditionalDeputate/modals/AdditionalDeputateModal';
import { InheritDeputateModal } from '../../../../components/AdditionalDeputate/modals/InheritDeputateModal';
import { AdditionalDeputateTable } from '../../../../components/AdditionalDeputate/tables/AdditionalDeputateTable';
import { Page } from '../../../../components/Page/Page';
import { useConfirm } from '../../../../hooks/useConfirm';
import { useMemorizedCacheTag } from '../../../../hooks/useMemorizedCacheTag';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';
import { useDeleteAdditionalTeachingLoadsMutation } from '../../../../types/planung-graphql-client-defs';
import { showSuccessDeleteToast, showUserErrorToast } from '../../../../utils/toast';

export const AdditionalDeputatePage = () => {
  const { t } = useTranslation();
  const context = useMemorizedCacheTag('ADDITIONAL_TEACHINGLOAD');
  const permissions = usePermissionChecker();

  const [deputateModalOpen, setDeputateModalOpen] = useState<boolean>(false);
  const [inheritModalOpen, setInheritModalOpen] = useState<boolean>(false);
  const [deputatUuid, setDeputatUuid] = useState<string | null>(null);

  const { confirm, ConfirmationDialog } = useConfirm();

  const [, deleteAdditionalTeachingLoad] = useDeleteAdditionalTeachingLoadsMutation();

  function handleAdd() {
    setDeputateModalOpen(true);
  }

  function handleInherit() {
    setInheritModalOpen(true);
  }

  function handleEdit(uuid: string) {
    setDeputatUuid(uuid);
    setDeputateModalOpen(true);
  }

  async function handleDelete(uuid: string) {
    const confirmed = await confirm({
      message: t('additionalTeachingLoads.deleteConfirm'),
    });

    if (confirmed) {
      const response = await deleteAdditionalTeachingLoad({ uuid: uuid }, context);
      if (response.error) {
        showUserErrorToast({ error: response.error });
      } else {
        showSuccessDeleteToast();
      }
    }
  }

  function handleClose() {
    setDeputatUuid(null);
    setDeputateModalOpen(false);
  }

  return (
    <Page isForbidden={!permissions?.canReadDeputate()} title={t('routes.deputate.additional.title')}>
      <AdditionalDeputateTable
        onAdd={handleAdd}
        onInherit={handleInherit}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      <AdditionalDeputateModal deputatUuid={deputatUuid} isOpen={deputateModalOpen} onClose={handleClose} />
      <InheritDeputateModal isOpen={inheritModalOpen} onClose={() => setInheritModalOpen(false)} />

      <ConfirmationDialog />
    </Page>
  );
};
